import { createGlobalState } from "@vueuse/core";
import { computed, shallowRef } from "vue";

export interface ActiveSidebarEntry {
  id: symbol
  title: () => string
  open: () => void
}

/**
 * Tracks the mounted VSidebars so the phone top bar can open the one for the current page.
 * The last mounted sidebar wins, which is the innermost one when routes nest them.
 */
export const useActiveSidebar = createGlobalState(() => {
  const entries = shallowRef<ActiveSidebarEntry[]>([]);

  const active = computed(() => entries.value.at(-1) ?? null);

  function register(entry: ActiveSidebarEntry) {
    entries.value = [...entries.value, entry];
    return () => {
      entries.value = entries.value.filter(item => item.id !== entry.id);
    };
  }

  return {
    active,
    register,
  };
});
